import { NgModule } from '@angular/core';
import { DevicesModule } from '../devices/devices.module';
import { FirmwaresModule } from '../firmwares/firmwares.module';
import { RouterTypesModule } from '../router-types/router-types.module';
import { SharedModule } from '../shared/shared.module';
import { TenantsModule } from '../tenants/tenants.module';
import { UsersModule } from '../users/users.module';
import { BaseRoutingModule } from './base-routing.module';
import { BaseComponent } from './base.component';
import { LanguageDialogComponent } from './dialogs/language-dialog/language-dialog.component';
import { Im2mCommonButtonComponent } from '@m2mgate/sage-ui';
import { Im2mMapComponent } from '@m2mgate/sage-ui/maps';

@NgModule({
    imports: [
        SharedModule,
        BaseRoutingModule,
        UsersModule,
        TenantsModule,
        DevicesModule,
        FirmwaresModule,
        RouterTypesModule,
        Im2mCommonButtonComponent,
        Im2mMapComponent,
    ],
    exports: [BaseComponent, LanguageDialogComponent],
    declarations: [BaseComponent, LanguageDialogComponent],
})
export class BaseModule {}
